const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.09 48.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35.44,3.13V45.6a3.2,3.2,0,0,0,3.2,3.2H42.7a3.2,3.2,0,0,0,3.2-3.2h0l0-42.46A3.14,3.14,0,0,0,42.8,0H38.71a3.15,3.15,0,0,0-3.27,3Z",
    style: {
      fill: "#00c0ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.35,44.47,7.29,21.24V38L0,35.63V10.13L5.35,8.57,31.44,27.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.42,29c3.29-1.95,5-4.7,5-8,0-5.4-2.68-9.55-15.34-14L49.77,2.9l0,9.58q6.07.84,12,2.29c4.68,1.22,7.7,3,7.7,5.47S67.17,23.79,61.85,24c-6.21.22-12,.19-12,.19l0,9.73L62.1,32.18l8.4,7.4,8.59-2.91Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.97d93c70c702877a97844332bffdc6f0.svg";
export { ForwardRef as ReactComponent };